var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge",class:[`badge--${_vm.tone}`, `badge--${_vm.size}`]},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }